<template>
  <div class="talentboxs com-model" style="padding: 20px 100px 80px;">
    <!--  搜索框  -->
    <div class="search-box flex">
      <div class="flex-grow input-box">
        <input ref="searchInput"
               @keyup.enter="gosearch"
               type="text"
               placeholder="意向岗位/籍贯/姓名"
               autofocus="true"
               class="search-inp"
               v-model="searchTxt"/>
      </div>
      <div class="primary-btn search-btn pointer" @click="gosearch">搜人才</div>
      <!--<dl class="search-history">
        <dt>搜索记录：</dt>
        <dd v-for="item in historyList" @click="historySearch(item)">{{item}}</dd>
        <dd v-if="historyList.length === 0">暂无搜索记录</dd>
      </dl>-->
    </div>
    <!--  条件框  -->
    <div class="condition-box">
      <dl class="condition-city hide">
        <dt>工作地点：</dt>
        <dd :class="{atuodd:isatuoddRess}">
          <div class="kdd" @click="citySel(item.id)" :class="{active:cityId === item.id}" v-for="item in cityArr">
            {{item.name}}
          </div>
        </dd>
        <!--<div class="condition-more" @click="isatuoddRess = !isatuoddRess">
          <span>{{isatuoddRess?'收起':'更多'}}</span>
          <i class="iconfont icon-arrow-down"/>
        </div>-->
      </dl>
      <dl class="condition-city">
        <dt>求职行业：</dt>
        <dd :class="{atuodd:isatuodd}">
          <div class="kdd"
               :class="{active:industryId === item.id}"
               @click="industryChange(item.id)"
               v-for="item in industryList">
            {{item.name}}
          </div>
        </dd>
        <div class="condition-more" @click="isatuodd = !isatuodd">
          <span>{{isatuodd?'收起':'更多'}}</span>
          <i class="iconfont icon-arrow-down"/>
        </div>
      </dl>
      <dl class="condition-city clearfix">
        <dt>性别要求：</dt>
        <dd>
          <div class="kdd" :class="{active:sex === item.value}" @click="sexChange(item.value)" v-for="item in sexList">
            {{item.name}}
          </div>
        </dd>
      </dl>
      <div :class="{hide:isShrink}">
        <dl class="condition-city clearfix">
          <dt>学历要求：</dt>
          <dd>
            <div class="kdd"
                 @click="educationChange(item.id)"
                 :class="{active:education === item.id}"
                 v-for="item in educationList">
              {{item.name}}
            </div>
          </dd>
        </dl>
        <dl class="condition-city clearfix">
          <dt>工作经验：</dt>
          <dd>
            <div class="kdd"
                 @click="experienceChange(item.id)"
                 :class="{active:experience === item.id}"
                 v-for="item in experienceList">
              {{item.name}}
            </div>
          </dd>
        </dl>
        <dl class="condition-city clearfix">
          <dt>薪资待遇：</dt>
          <dd>
            <div class="kdd"
                 :class="{active:item.min === minSalary && item.max === maxSalary}"
                 @click="salaryChange(item.min,item.max)"
                 v-for="item in salaryList">
              {{item.txt}}
            </div>
          </dd>
        </dl>
      </div>
      <!--<div class="condition-zd">
        <div class="condition-zdtxt" v-if="!isShrink" @click="isShrink = !isShrink">收起筛选</div>
        <div class="condition-zdtxt" style="color: #495fcd;" v-else @click="isShrink = !isShrink">显示筛选</div>
      </div>-->
    </div>
    <div class="search-result flex flex-between m-b-15">
      <div class="flex">
        <div class="title m-r-24">排序：</div>
        <div class="sort m-r-34 pointer" @click="sortChange('pubTime')">
          发布时间
          <img style="width: 15px; height: 15px"
               :src="require('../../assets/images/resume/sort_' + (sort!=='pubTime' ? 'default' : isAsc ? 'up' : 'down') + '_icon.png')"
               alt=""/>
        </div>
        <div class="sort pointer" @click="sortChange('experience')">工作年限
          <img style="width: 15px; height: 15px"
               :src="require('../../assets/images/resume/sort_' + (sort!=='experience' ? 'default' : isAsc ? 'up' : 'down') + '_icon.png')"
               alt=""/>
        </div>
      </div>
      <!--<p class="search-result-txt">为您搜索到<span>{{total}}位</span>满足条件的人才</p>
      <dl class="sort">
        <dt>
          <i class="iconfont icon-change_ico"/>
          <span>排序方式：</span>
        </dt>
        <dd class="sort-time" @click="sortChange('pubTime')" :class="{'active':sort === 'pubTime'}">发布时间</dd>
        <dd class="sort-year" @click="sortChange('experience')" :class="{'active':sort === 'experience'}">工作年限</dd>
      </dl>-->
    </div>
    <div>
      <template v-if="total">
        <div class="resume-list">
          <resume-item v-for="(item, index) in rowsList"
                       :key="item.id"
                       :item="item"
                       type="talent"
                       :index="index"
                       @downloadResume="downloadResume"/>

        </div>
        <!--<confirmLayer v-show='showAddResume' :id='addResumeId' :name='addResumeName' :close="hideAddResume"/>-->
        <new-confirm :visible.sync="showAddResume"
                     :name="addResumeName"
                     :workerId="addResumeId"
                     :type="true"
                     v-if="showAddResume"
                     @getList="getList"/>
        <!--<ztx-paging style="padding-bottom:22px;"
                    v-if="total >= 0"
                    :page-num="pageNum"
                    :pageTotal="total"
                    @currentChange="currentChange"/>-->
        <el-pagination @size-change="handleSizeChange"
                       @current-change="currentChange"
                       :current-page="pageNum"
                       :page-sizes="[10, 20, 30, 40]"
                       :page-size="pageSize"
                       layout="sizes, prev, next, jumper"
                       :total="total"/>
      </template>
      <template v-else>
        <no-data />
      </template>
      <!--<router-view></router-view>-->
    </div>
  </div>
</template>

<script>
  import NoData from '../../components/NoData.vue';
  import {cityList} from '../../datas/city.js';
  import Pageing from '../../components/Pageing';
  // import confirmLayer from './confirm.vue';
  import NewConfirm from "../../components/NewConfirm.vue";
  import ResumeItem from '../../components/resumeItem.vue';

  const qs = require('qs');

  export default {
    data() {
      return {
        isatuoddRess: false,
        isatuodd: false,
        rowsList: [],
        total: -1,
        pageNum: 1,
        pageSize: 10,
        industryList: [],
        educationList: [],
        experienceList: [],
        // searchTxt:'12314',
        isShrink: false, // 是否伸缩
        cityId: '',
        cityArr: cityList,
        industryId: '',
        education: '',
        sex: -1,
        experience: '',
        minSalary: '',
        maxSalary: '',
        historyList: [],
        sort: 'pubTime', // pubTime为发布时间 experience工作年限
        isAsc: false, // 升降序
        sexList: [
          { value: -1, name: '不限', },
          { value: 1, name: '男', },
          { value: 0, name: '女', }
        ],
        salaryList: [
          { txt: '不限', min: '', max: '' },
          { txt: '1500-2500', min: 1500, max: 2500 },
          { txt: '2500-3500', min: 2500, max: 3500 },
          { txt: '3500-5000', min: 3500, max: 5000 },
          { txt: '5000-8000', min: 3500, max: 8000 },
          { txt: '8000-10000', min: 8000, max: 10000 },
          { txt: '10000以上', min: 10000, max: 1000000 }
        ],
        showAddResume: false,
        addResumeId: '',//添加简历的id
        addResumeName: '',//添加简历的名字
      }
    },
    components: {
      ztxPaging: Pageing,
      // confirmLayer,
      NewConfirm,
      ResumeItem,
      NoData
    },
    created() {
      this.getInddustryList();
      this.getEducationList();
      this.getExperienceList();
      let historyLoc = window.localStorage.getItem('historyLoc');
      if (historyLoc) {
        this.historyList = historyLoc.split(',');
      }
    },
    mounted() {
      this.searchTxt = this.$route.query.value;
      this.$refs.searchInput.focus();
      this.getList();
    },
    beforeRouteUpdate(to, from, next) {
      if (from.path === '/index/searchList/conform') {
        this.getList();
      }
      next();
    },
    computed: {
      searchTxt: {
        get() {
          return this.$parent.searchContent;
        },
        set(val) {
          this.$parent.searchContent = val;
        }
      }
    },
    methods: {
      //历史记录搜索
      historySearch(item) {
        this.searchTxt = item;
        this.getList();
      },
      sortChange(sort) {
        if (sort === this.sort) {
          this.isAsc = !this.isAsc;
        } else {
          this.sort = sort;
        }
        this.getList();
      },
      handleSizeChange(val) {
        this.pageSize = val;
        this.getList();
      },
      currentChange(val) {
        this.pageNum = val;
        this.getList();
      },
      industryChange(val) {
        this.industryId = val;
        this.getList();
      },
      sexChange(val) {
        this.sex = val;
        this.getList();
      },
      // 城市选择
      citySel(val) {
        this.cityId = val;
        this.getList();
      },
      educationChange(val) {
        this.education = val;
        this.getList();
      },
      experienceChange(val) {
        this.experience = val;
        this.getList();
      },
      salaryChange(min, max) {
        this.minSalary = min;
        this.maxSalary = max;
        this.getList();
      },
      gosearch() {
        this.getList();
      },
      seeResume(id) {
        this.$router.push({ path: 'resume/seeinfo', query: { workerId: id } });
      },
      //隐藏添加人才弹层
      hideAddResume() {
        this.showAddResume = false;//隐藏添加人才弹层
      },
      //添加人才事件
      downloadResume(id, isAdd, name) {
        if (isAdd * 1 > 0) {
          return;
        }
        this.showAddResume = true;//显示添加人才弹层
        this.addResumeId = id;
        this.addResumeName = name;
      },
      getInddustryList: function () {
        this.axios.get('/wapi/baseData/listIndustry').then(res => {
          let rdata = res.data;
          rdata.unshift({
            id: '',
            name: '不限'
          });
          this.industryList = rdata;
        });
      },
      getEducationList: function () {
        this.axios.get('/wapi/baseData/listEducation').then(res => {
          let rdata = res.data;
          rdata.unshift({
            id: '',
            name: '不限'
          });
          this.educationList = rdata;
        });
      },
      getExperienceList: function () {
        this.axios.get('/wapi/baseData/listExperience').then(res => {
          let rdata = res.data;
          rdata.unshift({
            id: '',
            name: '不限'
          });
          this.experienceList = rdata;
        });
      },
      getList() {
        let url = `/wapi/hr/pageWorker`;
        let qdata = {
          keyword: this.searchTxt,
          cityId: this.cityId,
          industryId: this.industryId,
          sex: this.sex,
          education: this.education,
          minSalary: this.minSalary,
          maxSalary: this.maxSalary,
          experience: this.experience,
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          sort: this.sort,
          isAsc: this.isAsc
        };
        if (this.searchTxt !== undefined && this.searchTxt.length > 0) {
          let hilist = this.historyList;
          hilist.unshift(this.searchTxt);
          if (hilist.length > 0) {
            hilist = Array.from(new Set(hilist));
            if (hilist.length >= 5) {
              hilist.splice(5, 1);
            }
          } else {
            hilist = [this.searchTxt];
          }
          this.historyList = hilist;
        }
        window.localStorage.setItem('historyLoc', this.historyList);
        //let url = `/wapi/hr/pageWorker?keyword=${this.searchTxt}&cityId=${this.cityId}&industryId=${this.industryId}&sex=${this.sex}&education=${this.education}&minSalary=${this.minSalary}&maxSalary=${this.maxSalary}&experience=${this.experience}&pageNum=${this.pageNum}`;
        this.axios.post(url, qs.stringify(qdata)).then(res => {
          this.rowsList = res.rows;
          this.total = res.total;
        });
      }
    }
  }
</script>

<style scoped lang="less">
  @import url('../../assets/less/base.less');
  @import "../../assets/css/talent";

  .talentboxs {
    margin-left: 0;
    border-radius: 10px;
  }

  .resume-list .hasdownload {
    background-color: #ccc;
    border-color: #ccc;
    color: #fff;
    cursor: not-allowed;
  }

  .search-history {
    height: 14px;
    overflow: hidden;
  }

  .sort-time {
    cursor: pointer;
  }

  .sort-year {
    cursor: pointer;
  }

  .condition-box .condition-city .atuodd {
    height: auto;
  }

  .condition-box .condition-city .kdd {
    margin-bottom: 8px;
  }

  .resume-list .img {
    background: transparent;
    border-radius: 50%;
    -webkit-border-radius: 50%;
  }

  .resume-list .img img {
    border: 0;
    border-radius: 50%;
  }
</style>



// WEBPACK FOOTER //
// searchlist.vue?a4acf54a